export const customV21 = [
  {
    name: 'customV2_startPageV4',
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'customV2_age',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_info_breed',
  },
  {
    name: 'owner_feelings',
  },
  {
    name: 'owner_sleep',
  },
  {
    name: 'owner_puppy_behavior',
  },
  {
    name: 'owner_puppy_managing',
  },
  {
    name: 'owner_puppy_affect',
  },
  {
    name: 'owner_support',
  },
  {
    name: 'owner_concerns',
  },
  {
    name: 'info_about_owner',
  },
  {
    name: 'customV2_training_time',
  },
  {
    name: 'customV2_training',
  },
  {
    name: 'customV2_creating_program',
  },
  {
    name: 'customV2_plan',
  },
  {
    name: 'customV2_email',
  },
];
